<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <es-org-tree @clickByOrg="queryRosteringRuleList" @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header" class="card-header"><i class="el-icon-font el-icon-quyu el-icon--left"></i>排班规则</div>
          <div class="es-op-box">
            <el-input placeholder="请输入姓名" v-model="queryObj.keyWord" size="small" class="query"
              style="float: left;margin-bottom:10px" clearable
              @change="() => { this.queryObj.pageNum = 1; loadRosteringRuleList() }">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <el-table :data="pageData.list" ref="rosteringRuleTable" border stripe size="mini" height="calc(100vh - 250px)"
            v-loading="loading">
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="accountName" width="180" label="人员姓名">
            </el-table-column>
            <el-table-column prop="orgName" width="180" label="所属组织">
            </el-table-column>
            <el-table-column prop="rosteringName" width="180" label="排班类别名称">
            </el-table-column>
            <el-table-column prop="startDate" width="180" label="起始日期">
            </el-table-column>
            <el-table-column prop="cycle" width="180" label="循环周期">
            </el-table-column>
            <el-table-column prop="dutyRules" label="值班规律">
              <template slot-scope="scope">
                <span v-if="scope.row.dutyRules != null">{{ scope.row.dutyRules.replaceAll('1', '班').replaceAll('0',
                  '休')
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-link :underline="false" title="编辑" @click="edit_init(scope.row)" type="primary"><i
                    class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false" title="排班" @click="open_init(scope.row)" type="primary"><i
                    class="el-icon-s-claim"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="del(scope.row.id)" type="icon" :key="scope.row.id"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
              @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadRosteringRuleList() }">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑区域-->
    <el-dialog :visible.sync="editVisible" @closed="() => this.$refs['rosteringRuleForm'].clearValidate()" width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>排班规则
      </span>
      <el-form :model="rosteringRuleInfo" :rules="rules" size="mini" label-position="right" label-width="150px"
        ref="rosteringRuleForm">
        <el-form-item prop="accountName" label="人员姓名">
          <el-input v-model="rosteringRuleInfo.accountName" :disabled="true" placeholder="请输入人员姓名" style="width:200px"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="orgName" label="所属组织">
          <el-input v-model="rosteringRuleInfo.orgName" :disabled="true" placeholder="请输入所属组织" style="width:200px"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="orgName" label="所属组织">
          <el-input v-model="rosteringRuleInfo.orgName" :disabled="true" placeholder="请输入所属组织" style="width:200px"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="rosteringId" label="排班类型">
          <el-select ref="rosteringIdSelect" style="width:200px" size="mini" v-model="rosteringRuleInfo.rosteringId"
            placeholder="请选排班类型" clearable filterable>
            <el-option v-for="item in rosteringTypeAllList" :key="item.id" :label="item.name" :value="item.id"
              @click.native="getValue(item.name)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startDate" label="起始日期">
          <el-date-picker v-model="rosteringRuleInfo.startDate" value-format="yyyy-MM-dd" type="date" style="width:200px"
            placeholder="起始日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="cycle" label="循环周期">
          <el-input-number v-model="rosteringRuleInfo.cycle" :step="1" :min="1" :max="30" style="width:200px"
            step-strictly></el-input-number>
        </el-form-item>
        <el-form-item v-if="rosteringRuleInfo.cycle > 0" label="是否值班">
          <el-checkbox-group v-model="rosteringRuleInfo.checkedCycles" style="width:200px">
            <el-checkbox v-for="city in cities" size="mini" :label="city" :key="city">{{ '第' + city + '天'
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitRosteringRule()" :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
    <!--编辑区域-->
    <el-dialog :close-on-click-modal="false" :visible.sync="editRebornVisible" @closed="() => this.$refs['rosteringRebornForm'].clearValidate()" width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>生成排班
      </span>
      <el-form :model="rebornInfo" :rules="rebornRules" size="mini" label-position="right" label-width="150px"
        ref="rosteringRebornForm">
        <el-form-item prop="accountName" label="人员姓名">
          <el-input v-model="rebornInfo.accountName" :disabled="true" style="width:200px"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="month" label="生成月份">
          <el-date-picker
            v-model="rebornInfo.month"
            type="month"
            value-format="yyyyMM"
            placeholder="请选择月份">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="editRebornVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="edit_reborn()" :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'rosteringrule',
  props: ["funcs"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      orgTree: [],
      cities: [],
      rosteringTypeAllList: [],
      editVisible: false,
      rosteringRuleInfo: {},//区域信息
      rebornInfo:{},
      editRebornVisible:false,
      rules: {//验证条件
        rosteringId: [
          { required: true, message: '请输入选择排班类型', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '请选择起始日期', trigger: 'blur' }
        ]
      },
      rebornRules: {//验证条件
        month: [
          { required: true, message: '请选择月份', trigger: 'blur' }
        ]
      },
      loading: false,
      saving: false
    }
  },
  watch: {
    'rosteringRuleInfo.cycle' () {
      this.cities = [];
      for (var i = 1; i <= this.rosteringRuleInfo.cycle; i++) {
        this.$set(this.rosteringRuleInfo, 'checkedCycles', [])
        this.cities.push(i);
      }
    }
  },
  methods: {
    //页面初始化
    init () {
      this.listRosteringTypeAll()
      this.loadRosteringRuleList()
    },
    queryRosteringRuleList (orgIds) {
      this.queryObj.pageNum = 1;
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(",");
      }
      this.loadRosteringRuleList();
    },
    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },
    //获取线路名称
    getValue (val) {
      this.rosteringRuleInfo.rosteringName = val;
      this.$refs['rosteringRuleForm'].clearValidate();
    },
    listRosteringTypeAll () {
      this.loading = true
      this.$ajax.get('/buss/rostering/listRosteringTypeAll').then(msg => {
        this.rosteringTypeAllList = msg
        console.log('listRosteringTypeAll', this.rosteringTypeAllList);
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //从后台查询区域列表
    loadRosteringRuleList () {
      this.loading = true
      this.$ajax.get('/buss/rostering/listRosteringRule', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化添加区域
    add_init () {
      this.editVisible = true
      this.rosteringRuleInfo = {}
      this.$set(this.rosteringRuleInfo, 'checkedCycles', new Array())
    },
    //初始化编辑区域
    edit_init (row) {
      this.editVisible = true
      this.rosteringRuleInfo = JSON.parse(JSON.stringify(row))
      const checkedCycles = [];
      if (this.rosteringRuleInfo.dutyRules != null) {
        const arr = JSON.parse(this.rosteringRuleInfo.dutyRules);// eslint-disable-line no-unused-vars
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] === 1) {
            checkedCycles.push(i + 1);
          }
        }
      }
      this.$set(this.rosteringRuleInfo, 'checkedCycles', checkedCycles)
    },
    open_init (row) {
      this.editRebornVisible = true
      this.rebornInfo.accountId = row.accountId
      this.rebornInfo.accountName = row.accountName
    },
    edit_reborn () {
      this.$refs["rosteringRebornForm"].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$ajax.get('/buss/rostering/generatePlan', this.rebornInfo).then(msg => {
            this.loading = false;
            this.editRebornVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.loading = false;
          })
        }
      })
    },
    //保存区域信息
    submitRosteringRule () {
      this.$refs["rosteringRuleForm"].validate(valid => {
        if (valid) {
          console.log("rosteringRuleInfo", this.rosteringRuleInfo);
          const arr = new Array(this.rosteringRuleInfo.cycle).fill(0);// eslint-disable-line no-unused-vars
          this.rosteringRuleInfo.checkedCycles.forEach(e => {
            arr[e - 1] = 1;
          });
          this.rosteringRuleInfo.dutyRules = JSON.stringify(arr);
          console.log("rosteringRuleInfo", this.rosteringRuleInfo);
          let url = "/buss/rostering/addRosteringRule";
          if (this.rosteringRuleInfo.id != null) {
            url = "/buss/rostering/editRosteringRule";
          }
          this.saving = true
          this.$ajax.post(url, this.rosteringRuleInfo).then(msg => {
            this.saving = false
            this.loadRosteringRuleList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除区域信息
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["rosteringRuleTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/rostering/deleteRosteringRule', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadRosteringRuleList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped></style>
